import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import Layout from "@/components/Layout";
import api, { apiErr } from "@/lib/api";

export default function ChangePassword() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) return toast.error("La nueva contraseña debe tener al menos 6 caracteres");
    if (nw !== confirm) return toast.error("Las contraseñas nuevas no coinciden");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Contraseña actualizada");
      setCur(""); setNw(""); setConfirm("");
    } catch (err) { toast.error(apiErr(err)); } finally { setSaving(false); }
  };

  const field = (label, value, onChange, testid) => (
    <div>
      <label className="text-xs font-medium text-slate-500">{label}</label>
      <input type="password" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="mt-1.5 w-full px-3 py-2 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm" />
    </div>
  );

  return (
    <Layout>
      <div className="max-w-md">
        <h1 className="font-display text-2xl font-extrabold text-slate-900 flex items-center gap-2 mb-6">
          <KeyRound className="h-6 w-6 text-emerald-600" /> Cambiar contraseña
        </h1>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-lg p-6 space-y-4" data-testid="change-password-form">
          {field("Contraseña actual", cur, setCur, "cp-current")}
          {field("Nueva contraseña", nw, setNw, "cp-new")}
          {field("Confirmar nueva contraseña", confirm, setConfirm, "cp-confirm")}
          <button type="submit" disabled={saving} data-testid="cp-submit"
            className="flex items-center justify-center gap-2 w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold px-4 py-2.5 rounded-md transition-colors disabled:opacity-60">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Actualizar contraseña
          </button>
        </form>
      </div>
    </Layout>
  );
}
